import { create } from 'apisauce';
import constants from '../constants';
import drupal from '../utils/drupal';
import authMiddleware from './AuthMiddleware';
import api from './api';

var baseURL = constants.baseURL; // DEV

const download = require('downloadjs');
var FileSaver = require('file-saver');

// Alias
let AsyncStorage = window.localStorage;

const funcs = {
  login,
  forgotPassword,

  submitReceipt: (data = {}) => authMiddleware(submitReceipt, data), // Submit a receipt
  getHomeMessageContent: (data = {}) =>
    authMiddleware(getHomeMessageContent, data),
  getFaqContent: (data = {}) => authMiddleware(getFaqContent, data),
  getPrivacyContent: (data = {}) => authMiddleware(getPrivacyContent, data),
  getTermsContent: (data = {}) => authMiddleware(getTermsContent, data),
  fetchBackgroundImage: (data = {}) =>
    authMiddleware(fetchBackgroundImage, data),
  getExcelExport: (data = {}) => authMiddleware(getExcelExport, data),
  getCsvExport: (data = {}) => authMiddleware(getCsvExport, data),
  getMyOrganisations: (data = {}) => authMiddleware(getMyOrganisations, data),
  getUnitTypes: (data = {}) => authMiddleware(getUnitTypes, data),
  getAllImpact: (data = {}) => authMiddleware(getAllImpact, data), // get users individual impact
  getMyImpact: (data = {}) => authMiddleware(getMyImpact, data), // get users individual impact
  getTotalImpact: (data = {}) => authMiddleware(getTotalImpact, data),
  getMyDonations: (data = {}) => authMiddleware(getMyDonations, data), // Get users donations
  getReceiptMealcount: (data = {}) => authMiddleware(getReceiptMealcount, data)
};

export default funcs;

// email and password login
// Login User
function login(data) {
  return new Promise(async (resolve, reject) => {
    try {
      // login user
      let auth = await post(
        {
          endpoint: '/api/auth/login',
          data,
          headers: {
            'Content-Type': 'application/json'
          }
        },
        'There was an error logging in'
      );

      let token = auth.access_token;
      let refreshToken = auth.refresh_token;

      // get user with jwt
      let result = await get(
        {
          endpoint: '/api/me',
          data: {},
          headers: {
            Authorization: `Bearer ${token}`
          }
        },
        'There was an error logging in'
      );

      let user = result.results[0];

      await AsyncStorage.setItem('jwt', token);
      await AsyncStorage.setItem('refreshToken', refreshToken);

      return resolve(user);
    } catch (err) {
      return reject(err);
    }
  });
}

// Submit Receipt
function submitReceipt(data) {
  // login user
  return post(
    {
      endpoint: '/api/node',
      data,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${data.jwt}`
      }
    },
    'There was an error creating your receipt'
  );
}

function getMyImpact(data) {
  return new Promise(async (resolve, reject) => {
    // get user with jwt
    let impact = await get(
      {
        endpoint: '/api/individual_grow_impact',
        data,
        headers: {
          Authorization: `Bearer ${data.jwt}`
        }
      },
      'There was an error fetching your impact'
    );

    // impact = impact.results[0];

    return resolve(impact);
  });
}
function getAllImpact(data) {
  return new Promise(async (resolve, reject) => {
    // get user with jwt
    let impact = await get(
      {
        endpoint: '/api/total_grow_impact',
        data,
        headers: {
          Authorization: `Bearer ${data.jwt}`
        }
      },
      'There was an error fetching your impact'
    );

    // impact = impact.results[0];

    return resolve(impact);
  });
}

function getMyOrganisations(data) {
  return get(
    {
      endpoint: '/api/my_aid_organisations',
      data: {},
      headers: {
        Authorization: `Bearer ${data.jwt}`
      }
    },
    'There was an error fetching your aid organisations'
  );
}
function getUnitTypes(data) {
  return get(
    {
      endpoint: '/api/ffc_donation_units',
      data: {},
      headers: {
        Authorization: `Bearer ${data.jwt}`
      }
    },
    'There was an error fetching your aid organisations'
  );
}

function getTotalImpact(data) {
  return new Promise(async (resolve, reject) => {
    // get user with jwt
    let impact = await get(
      {
        endpoint: '/api/total_impact',
        data: {},
        headers: {}
      },
      'There was an error fetching total impact'
    );

    impact = impact[0];

    return resolve(impact);
  });
}

function getReceiptMealcount(data) {
  return new Promise(async (resolve, reject) => {
    // get user with jwt
    console.log('DSTS', data);
    let impact = await get(
      {
        endpoint: `/api/individual_impact?nid=${data.nid}`,
        data: {},
        headers: {
          Authorization: `Bearer ${data.jwt}`
        }
      },
      'There was an error fetching receipt total impact'
    );

    console.log('impact', impact);
    if (!impact) return reject('buuu');

    impact = impact[0];

    return resolve(impact);
  });
}

function getMyDonations(data) {
  return get(
    {
      endpoint: `/api/my_donation_log?page=${data.page}`,
      data: {},
      headers: {
        Authorization: `Bearer ${data.jwt}`
      }
    },
    'There was an error fetching your donations'
  );
}

// Send password reset
function forgotPassword(data) {
  return post(
    {
      endpoint: '/api/user/request_new_password',
      data,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${data.jwt}`
      }
    },
    'There was an error submitting your password reset'
  );
}

async function getHomeMessageContent(data) {
  let content = await get(
    {
      endpoint: '/api/node/151',
      data: {},
      headers: {
        Authorization: `Bearer ${data.jwt}`
      }
    },
    'There was an error fetching home page content'
  );

  return content.body.und[0].value;
}

async function getFaqContent(data) {
  let content = await get(
    {
      endpoint: '/api/node/152',
      data: {},
      headers: {
        Authorization: `Bearer ${data.jwt}`
      }
    },
    'There was an error fetching frequently asked questions content'
  );

  return content.body.und[0].value;
}

async function getPrivacyContent(data) {
  let content = await get(
    {
      endpoint: '/api/node/238',
      data: {},
      headers: {
        Authorization: `Bearer ${data.jwt}`
      }
    },
    'There was an error fetching privacy policy content'
  );

  return content.body.und[0].value;
}

async function getTermsContent(data) {
  let content = await get(
    {
      endpoint: '/api/node/153',
      data: {},
      headers: {
        Authorization: `Bearer ${data.jwt}`
      }
    },
    'There was an error fetching terms and conditions content'
  );

  return content.body.und[0].value;
}

async function fetchBackgroundImage(data) {
  return get(
    {
      endpoint: '/api/node/154',
      data: {},
      headers: {
        Authorization: `Bearer ${data.jwt}`
      }
    },
    'There was an error fetching the background image'
  );
}

async function getExcelExport(data) {
  let result = await get(
    {
      endpoint:
        '/api/individual_store_donation_export_excel?timestamp=' + Date.now(),
      data: {},
      headers: {
        Authorization: `Bearer ${data.jwt}`
      }
    },
    'There was an error fetching your excel export'
  );

  // return download(
  //   result,
  //   `donation-export-${Date.now()}.xls`,
  //   'application/vnd.ms-excel'
  // );

  var blob = new Blob([result], {
    type: 'application/vnd.ms-excel;charset=utf-8'
  });
  return FileSaver.saveAs(blob, `donation-export-${Date.now()}.xls`);
}

async function getCsvExport(data) {
  let result = await get(
    {
      endpoint:
        '/api/individual_store_donation_export_csv?timestamp=' + Date.now(),
      data: {},
      headers: {
        Authorization: `Bearer ${data.jwt}`
      }
    },
    'There was an error fetching your csv export'
  );

  //return download(result, `donation-export-${Date.now()}`, 'text/csv');
  var blob = new Blob([result], { type: 'text/csv;charset=utf-8' });
  return FileSaver.saveAs(blob, `donation-export-${Date.now()}.csv`);
}

//**********************************//
//
//       HELPER FUNCTIONS
//
//**********************************//

// Generic POST Request
function post(options, defaultErr = 'There was an error making that request') {
  return new Promise(function (resolve, reject) {
    const { endpoint, data, headers } = options;
    api
      .post(endpoint, data, { headers })
      .then(result => {
        console.log('res', result);
        // console.log('bu', JSON.stringify(result, null, 2));
        if (!result.ok) {
          console.log('post err');
          return reject(drupal.getError(result, defaultErr));
        }
        return resolve(result.data);
      })
      .catch(err => {
        return reject(err);
      });
  });
}

function put(options, defaultErr = 'There was an error making that request') {
  return new Promise(function (resolve, reject) {
    const { endpoint, data, headers } = options;
    api
      .put(endpoint, data, { headers })
      .then(result => {
        //alert(JSON.stringify(result, null, 2));
        if (!result.ok) {
          return reject(drupal.getError(result, defaultErr));
        }
        return resolve(result.data);
      })
      .catch(err => {
        return reject(err);
      });
  });
}

// Generic GET Request
function get(options, defaultErr = 'There was an error making that request') {
  return new Promise(function (resolve, reject) {
    const { endpoint, headers } = options;
    api
      .get(endpoint, {}, { headers })
      .then(result => {
        //alert(JSON.stringify(result, null, 2));
        if (!result.ok) {
          return reject(drupal.getError(result, defaultErr));
        }
        return resolve(result.data);
      })
      .catch(err => {
        return reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./src/api/index.js